import * as React from "preact";
import { FunctionComponent } from "preact";

import useWindowDimensions from "../../../../helpers/useWindowDimensions";
import constants from "../../../../helpers/constants";
import Concertina from "../../../components/Concertina";
import SearchTabs from "../../SearchTabs";
import Filters, { IFilterCategory } from "../Filters";

export interface IResults {
  loading: boolean;
  data: any;
  params: any;
  settings: any;
  currentPage?: number;
  filters: IFilterCategory[] | null;
  preSelectedFilters: string[];
  availableFilteredFilters : string[] | null;
  loadingFilters: boolean;
  resetFilters: boolean;
  handleFilters: (newFilters: string[], isClearFilter: boolean) => void;
  handleChangeSuperCategory: () => void;
  handleChangePage: (page: number) => void;
  handleSort: (e) => void;
  sortField: string;
  dataSaveStates: {contentId: string, state: boolean}[];
  fetchDataSaveLoading?: boolean;
  restrictToSavedItems: boolean;
  toggleRestrictToSavedItems: (state: boolean) => void;
}

const Results: FunctionComponent<IResults> = ({
  data,
  params,
  settings,
  loading,
  currentPage,
  filters,
  preSelectedFilters,
  loadingFilters,
  resetFilters,
  handleFilters,
  handleChangeSuperCategory,
  availableFilteredFilters,
  handleChangePage,
  handleSort,
  sortField,
  dataSaveStates,
  fetchDataSaveLoading,
  toggleRestrictToSavedItems,
  restrictToSavedItems,
}) => {
  const { width } = useWindowDimensions();
  const isMobile = width <= constants.breakpoints.mobileSearchFilters;

  return (
    <div className="search-results-scaffold__wrapper">
      <div className="search-results-scaffold__filters">
        {!isMobile && (
          <Filters
            filters={filters}
            handleFilters={handleFilters}
            preSelectedFilters={preSelectedFilters}
            resetFilters={resetFilters}
            settings={settings}
            loading={loadingFilters}
            availableFilteredFilters={availableFilteredFilters}
            restrictToSavedItems={restrictToSavedItems}
            toggleRestrictToSavedItems={toggleRestrictToSavedItems}
          ></Filters>
        )}
      </div>
      <SearchTabs
        data={data}
        params={params}
        loading={loading}
        settings={settings}
        currentPage={currentPage}
        handleChangeSuperCategory={handleChangeSuperCategory}
        handleChangePage={handleChangePage}
        handleSort={handleSort}
        sortField={sortField}
        dataSaveStates={dataSaveStates}
        fetchDataSaveLoading={fetchDataSaveLoading}
      >
        {isMobile && (
          <Concertina
            title={"Filters"}
            id="mobile-search-filters"
            isRichtext={false}
            isOpenByDefault
          >
            <Filters
              filters={filters}
              handleFilters={handleFilters}
              preSelectedFilters={preSelectedFilters}
              resetFilters={resetFilters}
              isMobile={true}
              settings={settings}
              availableFilteredFilters={availableFilteredFilters}
              restrictToSavedItems={restrictToSavedItems}
              toggleRestrictToSavedItems={toggleRestrictToSavedItems}
            />
          </Concertina>
        )}
      </SearchTabs>
    </div>
  );
};

export default Results;
